
import Constants from '../constants';
import {createStore} from 'redux';

const initialState = {
  loading: false,
  success: false,
  captchaSecurityId: '',
  displayedCaptcha: false,
  captchaBizCode: '',
  validation: {
    error: undefined,
    hasError: {},
    help: {},
  },
};
const reducer = function (state = initialState, action) {

  if (action.type === Constants.RESET_STORE) {
    return Object.assign({}, initialState);
  }

  if (action.type === Constants.LOGIN) {
    return Object.assign({}, initialState, {
      loading: true,
    });
  }

  if (action.type === Constants.LOGIN_RESPONSE) {
    return Object.assign({}, initialState, {
      success: Boolean(action.error) === false && (!action.data || !action.data.captchaSecurityId),
      validation: action.validation,
      displayedCaptcha: false,
      captchaSecurityId: action.data && action.data.captchaSecurityId,
      captchaBizCode: action.data && action.data.captchaBizCode,
    });
  }

  return state;
};


export default createStore(reducer);



// WEBPACK FOOTER //
// ./client/pages/main/login/home/store.js